module.exports = __webpack_public_path__ + "img/red&blue-chip.cebfa415.png";